import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, user } = useAuth();
    const location = useLocation();

    // Show loading spinner while auth state is being determined
    if (!user && isAuthenticated) {
        return <LoadingSpinner fullScreen />;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Render protected content
    return children;
};

export default PrivateRoute; 